import {bindActionCreators} from 'redux';

// Websocket Client
import CommsClient from './communications';
import {
    removeNoMoreBetsEvent,
    setNextEventsTimestamp,
    setNoMoreBetsEvent,
    setReceivedEvents
} from './actions/eventsActions';
import {setGameControllerState} from './actions/gamesActions';

// var systemIsStarted = false;

function initCallback(response) {
    return response;
}

function stateChangedCallback(response) {
    return response;
}

function errorCallback(response) {
    return response;
}

export default function (store, wsUrl) {
    let callbacksObject = bindActionCreators({
        initCallback,
        setEventsMessageCallback: setReceivedEvents,
        noMoreBetsMessageCallback: setNoMoreBetsEvent,
        videoFinishedPlayingMessageCallback: setReceivedEvents,
        setNextEventsTimestampCallback: setNextEventsTimestamp,
        noMoreBetsEndedMessageCallback: removeNoMoreBetsEvent,
        setGameControllerState: setGameControllerState,
        stateChangedCallback,
        errorCallback
    }, store.dispatch);

    let comms = new CommsClient(wsUrl);
    comms.addCallbacks(callbacksObject, store.dispatch);

    return comms;
}



// WEBPACK FOOTER //
// ./src/startWebsocket.js